import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import $ from "jquery";
// dataTables start
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-responsive";
import "datatables.net-responsive-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
// dataTables end

import "../public/src/sass/custom.scss";

window.$ = $;
window.jQuery = $;
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.min";

import Vue from "vue";
import { store } from "./store/store";
import VueRouter from "vue-router";
import App from "./App";
import { router } from "./router";
import moment from "moment";
import BootstrapVue from "bootstrap-vue";
import Vue2Filters from "vue2-filters";
import VueCurrencyInput from "vue-currency-input";
import "./util/customValidation";

import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
import tr from "vee-validate/dist/locale/tr.json";
import * as rules from "vee-validate/dist/rules";
import VueMask from "v-mask";

import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getRequiredPermissionTags } from "./util/pagePermissions";
import { installKeyRepeatGuard } from "./util/keyRepeatGuard";
import { installMemoryTelemetry } from "./util/memoryTelemetry";
import { safeHtml } from "./util/safe-html";
// import appConstants from "./plugins/appConstants";

const REPORT_PATH_PREFIX = "/rapor-sayfasi/";

// Install VeeValidate rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

//Install currencyInput
Vue.use(VueCurrencyInput);

localize("tr", tr);

Vue.use(BootstrapVue);
Vue.use(VueMask);
Vue.use(VueLoading);
Vue.use(Vue2Filters);

Vue.directive("safe-html", safeHtml);

Vue.use(VueRouter);
const routerWithOptions = new VueRouter({
  routes: router,
  mode: "history",
  props: ["pixiCanvas", "pixiCanvasType"],
  scrollBehavior(to, from, savedPosition) {
    // sayfa geçişlerinde sidebar menüyü kapat start
    const closeBtn = document.querySelector(".sidebar-menu-wrapper .btnClose");
    if (closeBtn) {
      closeBtn.click();
    }
    // sayfa geçişlerinde sidebar menüyü kapat end
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Deploy sonrası eski index.html nedeniyle yeni hashli chunk dosyalarına erişilemediğinde
// kullanıcıyı tek seferlik otomatik reload ile yeni sürüme taşır. sessionStorage guard'ı
// reload döngüsünü engeller; chunk hatası olmayan navigation davranışı değişmez.
routerWithOptions.onError((error) => {
  const message = (error && (error.message || error.toString())) || "";
  const isChunkError = /Loading chunk \S+ failed/i.test(message) || (error && error.name === "ChunkLoadError");
  if (!isChunkError) return;
  if (sessionStorage.getItem("__chunkReloadedAt__")) return;
  sessionStorage.setItem("__chunkReloadedAt__", String(Date.now()));
  window.location.reload();
});

// menu
routerWithOptions.beforeEach((to, from, next) => {
  // alert reset start (sayfa değiştiğinde sıfırlamak için)
  store.commit("setAlertText", "");
  store.commit("setAlertTitle", "");
  store.commit("setAlertVariant", "");
  store.commit("setAlertIcon", "");
  store.commit("setDismissCountDown", 0);
  // alert reset end
  // // version
  // if(!localStorage.getItem("appVersion")){
  //     localStorage.setItem("appVersion", appConstants.appVersion);
  // }if(Number(localStorage.getItem("appVersion")) !== appConstants.appVersion){
  //     localStorage.clear();
  //     localStorage.setItem("appVersion", appConstants.appVersion);
  // }
  // // version

  document.querySelectorAll(".dropdown-menu.show").forEach(function (el) {
    el.classList.remove("show");
  });
  // Store'da eski oturumlardan {} kalmış olabilir; yetki listesi her zaman dizi olarak ele alınır.
  const permissionTags = Array.isArray(store.getters.getUserPermissions) ? store.getters.getUserPermissions : [];
  const loggedIn = store.getters.getLoggedIn;
  // Sayfa yetkileri menü/arama ile aynı kaynaktan (util/pagePermissions.js) okunur; böylece aramada
  // görünmeyen bir sayfaya URL ile de girilemez. Kullanıcıda tag'lerden biri olması yeterlidir.
  let requiredPermissionTags = getRequiredPermissionTags(to.path);
  const callCenterUCId = to.query.Ucid;

  // Rapor sayfaları tek dinamik route ("/rapor-sayfasi/:slug") üzerinden açılır;
  // tanımlı olmayan rapor slug'ı için güvenli varsayılan yetkisiz sayfasıdır.
  if (!requiredPermissionTags && typeof to.path === "string" && to.path.startsWith(REPORT_PATH_PREFIX)) {
    requiredPermissionTags = [];
  }

  // Oturum açmamış kullanıcıyı App.vue giriş sayfasına yönlendirir. Oturum açmış kullanıcının yetki
  // listesi boşsa (birimde yetki yok ya da yetkiler alınamadı) yetki isteyen hiçbir sayfa açılmaz.
  const isAuthorized = !requiredPermissionTags || requiredPermissionTags.some((tag) => permissionTags.includes(tag));
  if (loggedIn && !isAuthorized) {
    next("/401");
  } else {
    // /401 sayfasına yönlendirilmiş mi kontrol et
    if (to.path === "/401" && from.path === "/401") {
      next(false);
    } else if (to.path === "/") {
      const showAlert = !callCenterUCId && permissionTags.includes("crs/rail-ivr/transfer-agent-call");
      store.commit("setCallCenterShowUCIdAlert", showAlert);
      if (!showAlert) store.commit("setCallCenterUCId", callCenterUCId);
      next();
    } else if (to.path === "/sifre-sifirla") {
      store.commit("setIsPasswordReset", true);
      next();
    } else {
      next(); // İzinler geçerliyse devam et
    }
  }
  //next();
  // sayfa geçişlerinde sidebar menüyü kapat start
  const closeBtnSideBarMenu = document.querySelector(".sidebar-menu-wrapper .btnClose");
  if (closeBtnSideBarMenu) {
    closeBtnSideBarMenu.click();
  }
  // sayfa geçişlerinde sidebar menüyü kapat end
});

Vue.filter("ddMMyyyyHHmmSS", function (value) {
  return moment(value).format("DD.MM.YYYY HH:mm");
});
Vue.filter("ddMMyyyy", function (value) {
  return moment(value).format("DD.MM.YYYY");
});
Vue.filter("ddMMyyyy_sefer_no", function (value) {
  return moment(value).format("DDMMYYYY");
});
Vue.filter("HHmm", function (value) {
  return moment.unix(value).format("HH:mm");
});
Vue.filter("yyyymmdd", function (value) {
  return moment(value).format("YYYY.MM.DD");
});

// Vue.prototype.imgCdnUrl = "http://uat-st.ditravo.com/src/";
// Vue.prototype.imgCdnUrl = "http://localhost:3000/src/";

installKeyRepeatGuard();
// Rastgele sekme çökmelerinin (Aw, Snap / code 5) bellek izini tutar; konsolda __b2bMemoryReport().
installMemoryTelemetry({ getRoute: () => routerWithOptions.currentRoute.path });

const vm = new Vue({
  el: "#app",
  router: routerWithOptions,
  mode: "history",
  store,
  render: (h) => h(App),
});
export default vm;
